import { useTypedQuery } from "hooks";
import { DealersDashboardQueryKeys } from "modules/DealersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { DealerLocationID } from "models";

export const useLocationDetailsQuery = (locationId: DealerLocationID) =>
  useTypedQuery({
    queryKey: DealersDashboardQueryKeys.locationDetails(locationId),
    queryFn: async ({ endpoint, baseUrl, params }) => (await ApiInstance.post(endpoint, params, baseUrl)).data
  });
